const cartItemTypes = {
    FRONT_WIPERS: "FRONT WIPERS",
    REAR_WIPERS: "REAR WIPERS",
    SUPPORTING_ITEMS: "SUPPORTING ITEMS",
    GLASS_PARTS: "GLASS PARTS",
    RAIN_REPEL: "RAIN REPEL",
    RECYCLE_FEE: "RECYCLE FEE",
    REPLACE_FEE: "REPLACE FEE",
    MOBILE_FEE: "MOBILE FEE",
    PROMOS: "PROMOS",
    EARLY_BIRD: "EARLY BIRD",
    SUPPLIES_REPAIR: "SUPPLIES-REPAIR",
    QUOTE_PAGE_DISCOUNT: "QUOTE PAGE DISCOUNT",
    DONATION: "DONATION",
};

export { cartItemTypes };
